import { getFeaturesEnabled } from 'src/slaughterhouseSpecific';

export const getHelptexts = ({ profile: { helptexts } }) => {
  return helptexts || {};

  const helptextsCpy = { ...helptexts };
  return helptextsCpy;
};

export const getProfile = ({ profile }) => profile;
export const getIsSuperuser = ({ profile }) => profile?.is_superuser?.is_superuser;
export const getPrognosisRegistrationConfig = ({
  profile: { prognosis_registration_config },
}) => prognosis_registration_config;
export const getPrognosisRegistration = ({
  profile: { prognosis_registration },
}) => prognosis_registration;
export const getPrognosisRegistrationIsAvailible = ({
  profile: { prognosis_registration_config },
}) => ['pigs', 'sheep', 'cattle'].filter((animalKind) => prognosis_registration_config?.config?.[animalKind]?.survey_available).length > 0 && getFeaturesEnabled().prognosisRegistration;
export const getPrognosisRegistrationShouldShowPopup = ({
  profile: { prognosis_registration_config },
}) => ['pigs', 'sheep', 'cattle'].filter((animalKind) => prognosis_registration_config?.config?.[animalKind]?.show_survey).length > 0 && getFeaturesEnabled().prognosisRegistration;
export const getPrognosisSubmitted = ({ profile: { prognosis_submitted } }) => prognosis_submitted;
export const getPrognosisStatistics = ({ profile: { prognosis_statistics } }) => prognosis_statistics;
export const getPrognosisPendingRegister = ({
  profile: { prognosis_pending_registration },
}) => prognosis_pending_registration;
